import { type MarketingCampaignRow } from "./hooks/useMarketingCampaigns";
import { toFiniteNumber } from "./marketingFormat";

export interface MarketingCampaignTotals {
  spend: number;
  bookingsTotal: number;
  bookingsPast: number;
  bookingsFuture: number;
  showed: number;
  sales: number;
  contractedValue: number;
  srPercent: number | null;
  costPerBooking: number | null;
  costPerShow: number | null;
  roas: number | null;
  cac: number | null;
}

const sum = (value: unknown): number => toFiniteNumber(value) ?? 0;

export const calculateMarketingCampaignTotals = (campaigns: MarketingCampaignRow[]): MarketingCampaignTotals => {
  const totals = campaigns.reduce(
    (result, campaign) => ({
      spend: result.spend + sum(campaign.spend),
      bookingsTotal: result.bookingsTotal + sum(campaign.bookingsTotal),
      bookingsPast: result.bookingsPast + sum(campaign.bookingsPast),
      bookingsFuture: result.bookingsFuture + sum(campaign.bookingsFuture),
      showed: result.showed + sum(campaign.showed),
      sales: result.sales + sum(campaign.sales),
      contractedValue: result.contractedValue + sum(campaign.contractedValue),
    }),
    {
      spend: 0,
      bookingsTotal: 0,
      bookingsPast: 0,
      bookingsFuture: 0,
      showed: 0,
      sales: 0,
      contractedValue: 0,
    },
  );

  return {
    ...totals,
    srPercent: totals.bookingsPast > 0 ? (totals.showed / totals.bookingsPast) * 100 : null,
    costPerBooking: totals.bookingsTotal > 0 ? totals.spend / totals.bookingsTotal : null,
    costPerShow: totals.showed > 0 ? totals.spend / totals.showed : null,
    roas: totals.spend > 0 ? totals.contractedValue / totals.spend : null,
    cac: totals.sales > 0 ? totals.spend / totals.sales : null,
  };
};
